import { Component, Input } from '@angular/core';

@Component({
    selector: 'cdp-select-summary',
    templateUrl: './select-summary.component.html',
    styleUrls: ['./select-summary.component.scss'],
    standalone: false
})
export class SelectSummaryComponent {
    @Input() items: any[];
    @Input() negatedItems?: any[];
    @Input() negatedItemTooltip?: string;
    @Input() linkText = 'selected';
    @Input() popupText = 'selected';
    @Input() primaryIcon = 'icon-table';
    @Input() singularItemName = 'job';
    @Input() pluralItemName = 'jobs';
    @Input() primaryPropName = 'entityName';
    @Input() secondaryPropName = 'ingestMode';
    @Input() tertiaryPropName = '';
    @Input() selectedHiddenRowCount = 0;

    isItemNegated(item: any): boolean {
        return (
            this.negatedItems?.some(
                negatedItem =>
                    negatedItem[this.primaryPropName] === item[this.primaryPropName] &&
                    negatedItem[this.secondaryPropName] === item[this.secondaryPropName]
            ) || false
        );
    }

    get hiddenRowText(): string {
        return this.selectedHiddenRowCount > 0 ? `, ${this.selectedHiddenRowCount} hidden` : '';
    }
}
